import api, { API_BASE_URL } from './api'

// List leads with filters
export const listLeads = (params = {}) => {
  const queryParams = new URLSearchParams()
  if (params.page) queryParams.append('page', params.page)
  if (params.limit) queryParams.append('limit', params.limit)
  if (params.status && params.status !== 'all') queryParams.append('status', params.status)
  if (params.source && params.source !== 'all') queryParams.append('source', params.source)
  if (params.assignedAgentId && params.assignedAgentId !== 'all') queryParams.append('assignedAgentId', params.assignedAgentId)
  if (params.search) queryParams.append('search', params.search)
  const queryString = queryParams.toString()
  return api.get(`/leads${queryString ? `?${queryString}` : ''}`)
}

// Get single lead by ID
export const getLead = (id) => api.get(`/leads/${id}`)

// Create new lead
export const createLead = (data) => api.post('/leads', data)

// Update lead
export const updateLead = (id, data) => api.put(`/leads/${id}`, data)

// Delete lead
export const deleteLead = (id) => api.delete(`/leads/${id}`)

// Bulk delete leads — body: { ids: [number, ...] }
export const bulkDeleteLeads = (ids) =>
  api.post('/leads/bulk-delete', { ids })

// Assign agent to lead
export const assignAgent = (leadId, assignedAgentId) =>
  api.post(`/leads/${leadId}/assign-agent`, { assignedAgentId })

// Bulk assign leads — body: { ids: [number, ...], assignedAgentId: string|null }
// Pass assignedAgentId=null to unassign.
export const bulkAssignLeads = (ids, assignedAgentId) =>
  api.post('/leads/bulk-assign', { ids, assignedAgentId })

// Patch one or more of clientId / ownerId / agencyId / assignedAgentId.
// Pass null to clear a relationship.
export const updateLeadRelationships = (id, fields) =>
  api.patch(`/leads/${id}/relationships`, fields)

// All leads from the same client (for "Other inquiries from this client").
export const listLeadsByClient = (clientId) =>
  api.get(`/leads/by-client/${clientId}`)

// Merge `otherId` into `id`. Keeps `id` as survivor.
export const mergeLeads = (id, otherId) =>
  api.post(`/leads/${id}/merge-from/${otherId}`)

// Update lead status
export const updateStatus = (leadId, status) =>
  api.patch(`/leads/${leadId}/status`, { status })

// Convert lead to booking
export const convertToBooking = (leadId, bookingId, bookingType = 'exclusive') =>
  api.post(`/leads/${leadId}/convert-to-booking`, { bookingId, bookingType })

// WordPress webhook endpoint (for testing)
export const fromWordpress = (data) => api.post('/leads/from-wordpress', data)

